import axios from 'axios'

function doPost (url, param) {
  return new Promise((next, error) => {
    axios.post(url, param).then(res => {
      if (res.data.code === 4001) {
        //未登录
        window.location.href = '/#/login'
        return
      }
      next(res)
    }).catch(err => {
      console.log(err)
      error(err)
    })
  })
}

function doGet (url) {
  return new Promise((next, error) => {
    axios.get(url).then(res => {
      if (res.data.code === 4001) {
        //未登录
        window.location.href = '/#/login'
        return
      }
      next(res)
    }).catch(err => {
      console.log(err)
      error(err)
    })
  })
}

function doDel (url) {
  return new Promise((next, error) => {
    axios.delete(url).then(res => {
      if (res.data.code === 4001) {
        //未登录
        window.location.href = ''
      }
      next(res)
    }).catch(err => {
      console.log(err)
      error(err)
    })
  })
}

export function doLogin (account, password) {
  return axios.post('/appeal/login/account', {
    account: account,
    password: password
  })
}

export function logout () {
  return doGet('/appeal/login/logout')
}

export function currentUser () {
  return doGet('/appeal/user/info')
}

export function resetPwd (newPass) {
  return doPost('/appeal/user/reset/psw', {
    password: newPass
  })
}

export function resetUserPwd (id, newPass) {
  return doPost('/appeal/user/reset/userPsw', {
    id: id,
    password: newPass
  })
}

export function listUser (page, size, param) {
  return doPost('/appeal/user/list', {
    page: page,
    size: size,
    param: param,
    order: 'create_time desc'
  })
}

export function listOrgUser(param) {
  return doPost('/appeal/user/listOrgUser',param)
}

export function addUser (param) {
  return doPost('/appeal/user/add', param)
}

export function userExport(param) {
  return new Promise((next, error) => {
    axios.request({
      url: '/appeal/user/export',
      headers: {
        'Content-Type': 'application/json',
        'accept': 'application/octet-stream'
      },
      method: 'POST',
      data: {
        param: param,
        order: 'create_time desc'
      },
      responseType: 'blob'
    }).then(res => {
      if (res.data.code === 4001) {
        //未登录
        window.location.href = '/#/login'
        return
      }
      next(res)
    }).catch(err => {
      console.log(err)
      error(err)
    })
  })
}

export function updateUser (param) {
  return doPost('/appeal/user/update', param)
}

export function deleteUser (id) {
  return doDel('/appeal/user/delete/'+id)
}

export function batchDeleteUser (ids) {
  return doPost('/appeal/user/batchDelete', ids)
}

export function detailUser(id) {
  return doGet('/appeal/user/detail/'+id)
}

export function allRole () {
  return doGet('/appeal/user/roles')
}

export function areaTree() {
  return doGet('/appeal/area/tree')
}

export function allArea(param) {
  return doGet('/appeal/area/all',{})
}

export function addArea(name,parentId) {
  return doPost('/appeal/area/add', {
    name: name,
    parentId: parentId
  })
}

export function updateArea(id, name, parentId) {
  return doPost('/appeal/area/update', {
    id: id,
    name: name,
    parentId: parentId
  })
}

export function deleteArea(id) {
  return doDel('/appeal/area/delete/'+id)
}

export function listOrg(page, size, param) {
  return doPost('/appeal/organ/list', {
    page: page,
    size: size,
    param: param,
    order: 'create_time desc'
  })
}

export function addOrg(param) {
  return doPost('/appeal/organ/add', param)
}

export function updateOrg (param) {
  return doPost('/appeal/organ/update', param)
}

export function deleteOrg (id) {
  return doDel('/appeal/organ/delete/'+id)
}

export function batchDeleteOrg (ids) {
  return doPost('/appeal/organ/batchDelete', ids)
}

export function listPark(page, size, param) {
  return doPost('/appeal/park/list', {
    page: page,
    size: size,
    param: param,
    order: 'create_time desc'
  })
}

export function addPark(param) {
  return doPost('/appeal/park/add', param)
}

export function updatePark (param) {
  return doPost('/appeal/park/update', param)
}

export function deletePark (id) {
  return doDel('/appeal/park/delete/'+id)
}

export function batchDeletePark (ids) {
  return doPost('/appeal/park/batchDelete', ids)
}

export function listDynamicDuty(page, size, param) {
  return doPost('/appeal/dynamicDuty/list', {
    page: page,
    size: size,
    param: param,
    order: 'create_time desc,update_time desc'
  })
}

export function getDynamicDuty(id) {
 return doGet('/appeal/dynamicDuty/' + id)
}

export function addDynamicDuty(contentInfo) {
  return doPost('/appeal/dynamicDuty/add', contentInfo)
}

export function updateDynamicDuty(contentInfo) {
  return doPost('/appeal/dynamicDuty/update', contentInfo)
}

export function deleteDynamicDuty (id) {
  return doDel('/appeal/dynamicDuty/delete/'+id)
}

export function listNotifyFile(page, size, param) {
  return doPost('/appeal/notify/list', {
    page: page,
    size: size,
    param: param,
    order: 'create_time desc'
  })
}

export function getNotifyFile(id) {
  return doGet('/appeal/notify/' + id)
}

export function addNotifyFile(contentInfo) {
  return doPost('/appeal/notify/add', contentInfo)
}

export function updateNotifyFile(contentInfo) {
  return doPost('/appeal/notify/update', contentInfo)
}

export function deleteNotifyFile (id) {
  return doDel('/appeal/notify/delete/'+id)
}

export function batchDeleteNotifyFile (ids) {
  return doPost('/appeal/notify/batchDelete', ids)
}

export function enterpriseAppealList(page, size, param) {
  return doPost('/appeal/enterpriseAppealInfo/list', {
    page: page,
    size: size,
    param: param,
    order: 'update_time desc'
  })
}

export function enterpriseAppeaExport(param) {
  return new Promise((next, error) => {
    axios.request({
      url: '/appeal/enterpriseAppealInfo/export',
      headers: {
        'Content-Type': 'application/json',
        'accept': 'application/octet-stream'
      },
      method: 'POST',
      data: {
        param: param,
        order: 'create_time desc'
      },
      responseType: 'blob'
    }).then(res => {
      if (res.data.code === 4001) {
        //未登录
        window.location.href = '/#/login'
        return
      }
      next(res)
    }).catch(err => {
      console.log(err)
      error(err)
    })
  })
}

export function enterpriseAppealDelivery(param) {
  return doPost('/appeal/enterpriseAppealInfo/delivery',param)
}

export function enterpriseAppealDeal(param) {
  return doPost('/appeal/enterpriseAppealInfo/deal',param)
}

export function enterpriseAppealBatchShowSet(ids,showOrgName,showContent) {
  return doPost('/appeal/enterpriseAppealInfo/showset/batch',{
    ids: ids,
    showOrgName: showOrgName,
    showContent: showContent
  })
}

export function enterpriseAppealWithdraw(param) {
  return doPost('/appeal/enterpriseAppealInfo/withdraw',param)
}

export function enterpriseAppealSet(param) {
  return doPost('/appeal/enterpriseAppealInfo/showSet',{
    id: param.id,
    showOrgName: param.showOrgName,
    showContent: param.showContent
  })
}

export function enterpriseAppealNotify() {
  return doGet('/appeal/enterpriseAppealInfo/hasHandle')
}

export function enterpriseAppealFile(appealId) {
  return doGet('/appeal/enterpriseAppealInfo/files/' + appealId)
}

export function enterpriseAppealFinishFile(appealId) {
  return doGet('/appeal/enterpriseAppealInfo/finishFiles/' + appealId)
}

export function enterpriseAppealDelayFile(appealId) {
  return doGet('/appeal/enterpriseAppealInfo/delayFiles/' + appealId)
}

export function enterpriseAppealDelete(appealId) {
  return doDel('/appeal/enterpriseAppealInfo/delete/' + appealId)
}

export function enterpriseAppealApplyDelay(delayInfo) {
  return doPost('/appeal/enterpriseAppealInfo/applyDelay',delayInfo)
}

export function listAppealDelayApply(page, size, param) {
  return doPost('/appeal/enterpriseAppealInfo/listDelayApply', {
    page: page,
    size: size,
    param: param,
    order: 'update_time desc'
  })
}

export function verifyAppealDelay(param) {
  return doPost('/appeal/enterpriseAppealInfo/delayVerify',param)
}

export function staticsAreaAppeal(type,startTime,endTime) {
  return doPost('/appeal/statics/area',{
    type: type,
    startTime: startTime,
    endTime:endTime
  })
}

export function staticsAppealTime(type) {
  return doGet('/appeal/statics/appeal/' + type)
}

export function staticsAppealStatus(type,startTime,endTime) {
  return doPost('/appeal/statics/appealStatus',{
    type: type,
    startTime: startTime,
    endTime:endTime
  })
}

export function userRegisterSms(phone,type) {
  return doPost('/appeal/portal/info/register/sms', {
    phone: phone,
    type:type
  })
}

export function userRegister(userInfo) {
  return doPost('/appeal/portal/info/register',userInfo)
}

export function appealInfoIndex() {
  return doGet('/appeal/portal/info/index/appeal')
}

export function notifyFileIndex() {
  return doGet('/appeal/portal/info/index/notifyFile')
}

export function dynamicDutyIndex() {
  return doGet('/appeal/portal/info/index/dynamicDuty')
}

export function portalUserInfo() {
  return doGet('/appeal/portal/user/info')
}

export function portalUserAccountLogin(account, password) {
  return doPost('/appeal/portal/user/account/login',{
    account: account,
    password: password
  })
}

export function portalUserSmsLogin(phone, captcha) {
  return doPost('/appeal/portal/user/sms/login',{
    phone: phone,
    captcha: captcha
  })
}

export function portalUserLogout() {
  return doGet('/appeal/portal/user/logout')
}

export function portalUserUpdate(param) {
  return doPost('/appeal/portal/user/update',param)
}

export function portalUserModifyPass(oldPass,newPass) {
  return doPost('/appeal/portal/user//modify/password',{
    oldPass: oldPass,
    newPass: newPass
  })
}

export function portalEnterpriseAppeal(appealInfo) {
  return doPost('/appeal/portal/appeal/enterprise', appealInfo)
}

export function portalEnterpriseAppealPay(appealInfo) {
  return doPost('/appeal/portal/appeal/payInfo', appealInfo)
}

export function portalEnterpriseAppealList(page, size, param) {
  return doPost('/appeal/portal/appeal/list', {
    page: page,
    size: size,
    param: param,
    order: 'update_time desc'
  })
}

export function portalAppealInfo(id) {
  return doGet('/appeal/portal/appeal/info/' + id)
}

export function portalStatics() {
  return doGet('/appeal/portal/appeal/statics')
}

export function portalAppealInfoEdit(appealInfo) {
  return doPost('/appeal/portal/appeal/edit', appealInfo)
}

export function portalEnterpriseAppealFile(appealId) {
  return doGet('/appeal/portal/appeal/files/' + appealId)
}

export function portalAppealFeedback(appealId, fileUrl) {
  return doPost('/appeal/portal/appeal/feedbackFile',{
    id: appealId,
    opinionFile: fileUrl
  })
}

export function portalNotify(page, size, param) {
  return doPost('/appeal/portal/notifyFile/list', {
    page: page,
    size: size,
    param: param,
    order: 'create_time desc'
  })
}

export function portalNotifyDetail(id) {
  return doGet('/appeal/portal/notifyFile/detail/' + id)
}

export function portalDuty(page, size, param) {
  return doPost('/appeal/portal/duty/list', {
    page: page,
    size: size,
    param: param,
    order: 'create_time desc'
  })
}

export function portalDutyDetail(id) {
  return doGet('/appeal/portal/duty/detail/' + id)
}

export function portalDictionary(type) {
  return doGet('/appeal/portal/info/dictionary/'+ type)
}

export function portalAreaTree() {
  return doGet('/appeal/portal/info/area/tree')
}

export function portalOrganizationList(name) {
  return doPost('/appeal/portal/info/organization/list',{
    page: 1,
    size: 999,
    param: {
      name: name
    },
    order: 'create_time desc'
  })
}

export function portalParkList(name,areaId) {
  return doPost('/appeal/portal/info/park/list',{
    page: 1,
    size: 999,
    param: {
      name: name,
      areaId: areaId
    },
    order: 'create_time desc'
  })
}



// WEBPACK FOOTER //
// ./src/api/restapi.js